const CARD_TYPES = {
  mention: {
    fields: ["name", "time", "context", "detail"],
  },
  section: {
    fields: ["type", "title", "content"],
  },
};

const CARD_TYPE_NAMES = Object.keys(CARD_TYPES);

const COMPLETE_BLOCK_REGEX = new RegExp(
  "```(" + CARD_TYPE_NAMES.join("|") + ")\\n([\\s\\S]*?)```",
  "g"
);

const INCOMPLETE_BLOCK_REGEX = new RegExp(
  "```(" + CARD_TYPE_NAMES.join("|") + ")\\n([\\s\\S]*)$"
);

function tryParseJson(str) {
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
}

function repairAndParse(fragment) {
  if (!fragment || !fragment.trim()) return null;

  const direct = tryParseJson(fragment);
  if (direct) return direct;

  let repaired = fragment.trim();
  const quoteCount = (repaired.match(/(?<!\\)"/g) || []).length;
  if (quoteCount % 2 !== 0) repaired += '"';

  const closers = [
    "}", "]", "]}", "]}",
    '"}', '"]', '"]}', '"}]',
    "}]}", "]}}", '"}]}',
  ];
  for (const closer of closers) {
    const parsed = tryParseJson(repaired + closer);
    if (parsed && typeof parsed === "object") return parsed;
  }

  return extractFieldsWithRegex(fragment);
}

function extractFieldsWithRegex(fragment) {
  const result = {};

  const stringFields = [...fragment.matchAll(/"(\w+)"\s*:\s*"((?:[^"\\]|\\.)*)"/g)];
  for (const [, key, value] of stringFields) {
    result[key] = value;
  }

  const arrayMatch = fragment.match(/"content"\s*:\s*\[([\s\S]*)/);
  if (arrayMatch) {
    const headings = [...fragment.matchAll(/"heading"\s*:\s*"((?:[^"\\]|\\.)*)"/g)].map(m => m[1]);
    const bodies = [...fragment.matchAll(/"body"\s*:\s*"((?:[^"\\]|\\.)*)"/g)].map(m => m[1]);
    if (headings.length > 0) {
      result.content = headings.map((h, i) => ({
        heading: h,
        body: bodies[i] || "",
      }));
    }
  }

  return Object.keys(result).length > 0 ? result : null;
}

export function parseStreamingText(text) {
  const completedCards = [];

  for (const match of text.matchAll(COMPLETE_BLOCK_REGEX)) {
    const cardType = match[1];
    const parsed = tryParseJson(match[2]);
    if (parsed) {
      completedCards.push({ cardType, data: parsed, isStreaming: false });
    }
  }

  const textWithoutComplete = text.replace(COMPLETE_BLOCK_REGEX, "");

  let streamingCard = null;
  const incompleteMatch = textWithoutComplete.match(INCOMPLETE_BLOCK_REGEX);
  if (incompleteMatch) {
    const cardType = incompleteMatch[1];
    const fragment = incompleteMatch[2];
    const data = repairAndParse(fragment);
    if (data) {
      streamingCard = { cardType, data, isStreaming: true };
    } else {
      streamingCard = { cardType, data: {}, isStreaming: true };
    }
  }

  const plainText = textWithoutComplete
    .replace(INCOMPLETE_BLOCK_REGEX, "")
    .trim();

  return { plainText, completedCards, streamingCard };
}

export function getCardFields(cardType) {
  return CARD_TYPES[cardType]?.fields || [];
}
